import Hero from "./components/Hero";
import ProblemSection from "./components/ProblemSection";
import MethodSection from "./components/MethodSection";
import AboutSection from "./components/AboutSection";
import PathwaySection from "./components/PathwaySection";
import CoursesSection from "./components/CoursesSection";
import TestimonialSection from "./components/TestimonialSection";
import AiSection from "./components/AiSection";
import FinalCta from "./components/FinalCta";
import Seo from "@/components/base/Seo";
import { webSiteSchema, organizationSchema } from "@/lib/seo";

export default function Home() {
  return (
    <>
      <Seo
        title="許文彰｜幸福人才總教練｜從知道，到做到，再到持續做到"
        description="幸福人才養成系統由許文彰（幸福人才總教練）整合工程、企業管理與人才培育經驗，協助個人找出行動卡點、建立可持續的成長方式，並為企業與團隊提供人才培育、目標管理與學習轉化的培訓方案，陪伴你從知道到做到、從做到到持續做到。"
        keywords="幸福人才,許文彰,幸福人才養成系統,企業培訓,個人成長,人才培育,行動卡點"
        jsonLd={[webSiteSchema, organizationSchema]}
      />
      <Hero />
      <ProblemSection />
      <MethodSection />
      <AboutSection />
      <PathwaySection />
      <CoursesSection />
      <TestimonialSection />
      <AiSection />
      <FinalCta />
    </>
  );
}